import { z } from "zod"
import { paginatedSearch, stringList } from "./search"

export const createCompanySchema = z.object({
	name: z
		.string()
		.trim()
		.min(1, "Company name is required")
		.max(200, "Name is too long"),
	status: z.enum(["prospect", "lead", "customer", "churned"]),
	category: z
		.enum([
			"",
			"shipowner",
			"charterer",
			"doc_holder",
			"registry",
			"bank_finance",
			"supplier",
			"other",
		])
		.refine((value) => value !== "", { message: "Category is required" }),
	country: z.string(),
	accountOwnerUserId: z.string(),
})
export type CreateCompanyInput = z.input<typeof createCompanySchema>

export const companiesSearchSchema = z.object({
	tab: z.enum(["customers", "leads", "prospects"]).optional().catch(undefined),
	q: z.string().default("").catch(""),
	...paginatedSearch({ columnId: "totalActions", direction: "desc" }),
	product: stringList,
	accountOwnerEmail: stringList,
	kycStatus: stringList,
})

export type CompaniesSearch = z.output<typeof companiesSearchSchema>
